export default __webpack_public_path__ + "static/media/notSuitableForInfants.d0a4b5ff.svg";